import type {
  ExtendedConstraints,
  CapabilityConfig,
  EventHandlerCb,
} from '../types';

export const id = 'system';

export enum Events {
  CapabilityOnline = 'system:capability-online',
  CapabilityOffline = 'system:capability-offline',
  CapabilitiesOnline = 'system:capabilities-online',
}

export enum Actions {}

export type CapabilityId = string;

export type Constraints = ExtendedConstraints<{
  events: Events;
  eventPayloadTuple:
    | [Events.CapabilityOnline, CapabilityId]
    | [Events.CapabilityOffline, CapabilityId]
    | [Events.CapabilitiesOnline, CapabilityId[]];
  eventHandlerTuple:
    | [Events.CapabilityOnline, EventHandlerCb<CapabilityId>]
    | [Events.CapabilityOffline, EventHandlerCb<CapabilityId>]
    | [Events.CapabilitiesOnline, EventHandlerCb<CapabilityId[]>];
}>;

export function isValidConfig(v: CapabilityConfig): boolean {
  return typeof v === 'object';
}
